/* ==========================================================================
   CRUXSTAR MOTION LAYER — v1.0
   No dependencies. ~2.5KB. Loaded with defer, so it never blocks render.
   Everything here is progressive: if this file fails to load, the site is
   simply the stock Dawn site. Nothing breaks.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     1. HEADER — add .cx-stuck once the user has scrolled off the hero
     ------------------------------------------------------------------ */
  var header = document.querySelector('.section-header');
  if (header) {
    var lastStuck = false;
    var syncHeader = function () {
      var stuck = window.scrollY > 80;
      if (stuck !== lastStuck) {
        header.classList.toggle('cx-stuck', stuck);
        lastStuck = stuck;
      }
    };
    window.addEventListener('scroll', syncHeader, { passive: true });
    syncHeader();
  }

  /* ------------------------------------------------------------------
     2. PARALLAX — banner + image-with-text media drift against the scroll
     rAF-throttled and only ever touches a CSS custom property, so it
     stays on the compositor and never triggers layout.
     ------------------------------------------------------------------ */
  if (!reduce && window.matchMedia('(min-width: 750px)').matches) {
    var layers = [].slice.call(
      document.querySelectorAll('.banner__media, .image-with-text__media')
    );

    if (layers.length) {
      layers.forEach(function (el) { el.classList.add('cx-parallax'); });

      var ticking = false;
      var drawParallax = function () {
        var vh = window.innerHeight;
        layers.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;   // offscreen, skip
          // -1 (below fold) .. 1 (above fold)
          var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
          el.style.setProperty('--cx-shift', (progress * -26).toFixed(2) + 'px');
        });
        ticking = false;
      };

      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(drawParallax); }
      }, { passive: true });
      window.addEventListener('resize', drawParallax, { passive: true });
      drawParallax();
    }
  }

  /* ------------------------------------------------------------------
     3. COUNT-UP — <span class="cx-count" data-to="250">0</span>
     Drop these into any Custom Liquid block. Optional data-prefix /
     data-suffix / data-dur attributes.
     ------------------------------------------------------------------ */
  var counters = [].slice.call(document.querySelectorAll('.cx-count'));
  if (counters.length && 'IntersectionObserver' in window) {
    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        countObserver.unobserve(el);

        var to     = parseFloat(el.dataset.to || '0');
        var prefix = el.dataset.prefix || '';
        var suffix = el.dataset.suffix || '';
        var dur    = parseInt(el.dataset.dur || '1600', 10);

        if (reduce) { el.textContent = prefix + to.toLocaleString() + suffix; return; }

        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);            // easeOutCubic
          el.textContent = prefix + Math.floor(to * eased).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + to.toLocaleString() + suffix;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.45 });

    counters.forEach(function (el) { countObserver.observe(el); });
  }

  /* ------------------------------------------------------------------
     4. STAGGER SAFETY
     Dawn sets --animation-order on some sections but not all. Backfill it
     on grids so reveals cascade instead of firing as one block.
     ------------------------------------------------------------------ */
  if (!reduce) {
    [].slice.call(document.querySelectorAll('.multicolumn-list, .grid')).forEach(function (grid) {
      [].slice.call(grid.children).forEach(function (child, i) {
        if (!child.style.getPropertyValue('--animation-order')) {
          child.style.setProperty('--animation-order', i);
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     5. THEME EDITOR SUPPORT
     Re-run everything when you add or move a section in the customizer,
     so you're not previewing a half-dead page.
     ------------------------------------------------------------------ */
  document.addEventListener('shopify:section:load', function () {
    window.dispatchEvent(new Event('scroll'));
  });
})();
